module.exports = __webpack_public_path__ + "static/anemia_due_to_ckd_patho_combined-e61c72e3269485277b5d7d7bbf4b260f.mp4";